import { useMemo, useRef, useState } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import Radio from '@mui/material/Radio'
import Typography from '@mui/material/Typography'
import { post } from '../../tools/request'

import { useAppSelector } from '~/store'

export default function GenerateTaxInvoiceModal({ open, salesFilter, onClose }) {
    const { exportDocumentsAPIURL } = useAppSelector((state) => state.initial.endpoints)
    const taxInvoiceFormats = useAppSelector((state) => state.initial.taxInvoiceFormats)
    const defaultFormatOption = useMemo(
        () => taxInvoiceFormats.find((item) => item.is_default) || taxInvoiceFormats[0],
        [taxInvoiceFormats]
    )
    const [selectedFormat, setSelectedFormat] = useState(defaultFormatOption)
    const [selectedIndex, setSelectedIndex] = useState(
        taxInvoiceFormats.indexOf(defaultFormatOption)
    )

    const [displayScreen, setDisplayScreen] = useState('export')
    const [loading, setLoading] = useState(false)
    const [createdExportDocument, setCreatedExportDocument] = useState({})

    const containerRef = useRef()

    const submitSalesExport = async () => {
        setLoading(true)
        const res = await post(exportDocumentsAPIURL, {
            document_type: 'tax_invoice',
            status: 'waiting',
            name: 'Tax Invoices',
            sale_filter: salesFilter,
            document_format_id: selectedFormat.document_format_id,
            document_format_option_id: selectedFormat.document_format_option_id,
        })
        setCreatedExportDocument(res)
        setLoading(false)
        setDisplayScreen('submitted')
    }

    const handleClose = () => {
        onClose()
        setDisplayScreen('export')
        setCreatedExportDocument({})
    }

    const handleViewExports = () => {
        window.open('/home/sales/exports', '_blank')
    }

    const handleToggle = (i) => () => {
        setSelectedFormat(taxInvoiceFormats[i])
        setSelectedIndex(i)
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth ref={containerRef}>
            <DialogTitle>{gettext('Invoices')}</DialogTitle>
            <DialogContent>
                {displayScreen === 'export' && (
                    <div>
                        <Typography variant="body2">
                            {gettext('Select tax invoice type')}
                        </Typography>
                        <List dense>
                            {taxInvoiceFormats.map(
                                (
                                    {
                                        document_format_id: id,
                                        document_format_name: name,
                                        document_format_image_url: image,
                                    },
                                    i
                                ) => (
                                    <ListItem key={i} onClick={handleToggle(i)}>
                                        <ListItemIcon>
                                            <Radio
                                                name={'choices'}
                                                value={id}
                                                inputProps={{
                                                    'aria-labelledby': `label-${name}`,
                                                }}
                                                checked={selectedIndex == i}
                                            />
                                        </ListItemIcon>
                                        <span>{name}</span>
                                        {image && (
                                            <Box
                                                component="img"
                                                id={`label-${name}`}
                                                src={image}
                                                alt={name}
                                                title={name}
                                                sx={{ maxHeight: 20 }}
                                            />
                                        )}
                                    </ListItem>
                                )
                            )}
                        </List>
                    </div>
                )}
                {displayScreen === 'submitted' && (
                    <Typography variant="body2" style={{ marginBottom: 24 }}>
                        {interpolate(gettext('File %s is generating'), [
                            createdExportDocument.name,
                        ])}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2, mt: 0 }}>
                {displayScreen === 'export' && (
                    <>
                        <Button color="secondary" onClick={handleClose}>
                            {gettext('Cancel')}
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            disabled={loading}
                            onClick={submitSalesExport}
                        >
                            {gettext('Export')}
                        </Button>
                    </>
                )}
                {displayScreen === 'submitted' && (
                    <>
                        <Button color="secondary" onClick={handleClose}>
                            {gettext('Close')}
                        </Button>
                        <Button variant="contained" color="secondary" onClick={handleViewExports}>
                            {gettext('Go to exports')}
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    )
}
